import clsx from '@vangst/lib/clsx'
import { BlogPostFragment, Tags } from '@vangst/services/graphcms/types'
import Routes from '@vangst/services/routes'
import Image from 'next/image'
import { memo } from 'react'
import ClickyExplore from '../../components/navigation/ClickyExplore'

type PropsType = {
  posts: BlogPostFragment[]
} & React.HTMLAttributes<HTMLDivElement>

function BlogPostsResults(props: PropsType) {
  const { className, posts } = props
  const isZeroState = posts?.length === 0

  const hrefMap = (slug: string) => {
    const lower = slug?.toLowerCase()
    if (lower?.includes('2024-cannabis-jobs-report')) {
      return Routes.REPORTS_JOBS_2024_VANGST
    }
    if (lower?.includes('common-cannabis-gig-jobs')) {
      return 'https://www.vangst.com/vangst-blog/common-cannabis-gig-jobs'
    }
    if (lower?.includes('what-is-gig-work')) {
      return 'https://www.vangst.com/vangst-blog/what-is-gig-work'
    }
    if (lower?.includes('the-power-of-temp-to-hire-staffing-solutions')) {
      return 'https://www.vangst.com/vangst-blog/the-power-of-temp-to-hire-staffing-solutions'
    }
    return Routes.BLOG_DETAIL.replace(':slug', slug)
  }

  return (
    <>
      <ol id="view-all-posts" className={clsx('grid', className)}>
        {posts?.map((post) => {
          const ctaCategory = post?.tags?.includes(Tags.Help)
            ? 'Help Topic'
            : post?.tags?.includes(Tags.Reports)
            ? 'Report'
            : 'Post'
          return (
            <li key={`post-${post.id}`} className="relative">
              <div className="relative h-64 w-full">
                <Image
                  alt={post.metaTitle}
                  className="h-auto max-w-full rounded-2xl object-cover"
                  fill
                  sizes="(min-width: 64em) 50vw, (min-width: 86em) 86em, 100vw"
                  src={
                    post?.imageUrl != null
                      ? post.imageUrl
                      : Routes.DEFAULT_VANGST_LOGO
                  }
                />
              </div>
              <div className="flow-y-xs mt-4 h-52">
                <h2 className="line-clamp-3 h-24 heading-xs">{post.title}</h2>
                <p className="line-clamp-2 text-sm text-grey">
                  {post.description}
                </p>
                <ClickyExplore
                  className="mt-auto"
                  title={`Learn More: ${post.title}`}
                  href={hrefMap(post.metaSlug)}
                >
                  View {ctaCategory}
                </ClickyExplore>
              </div>
            </li>
          )
        })}
      </ol>
      {isZeroState && <p>0 results found.</p>}
    </>
  )
}

export default memo(BlogPostsResults)
